jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.signposting').length ) {
        let $ = jQuery;

        $(".signposting .signposts").on('init', function(event, slick){
            if($(window).width() >= 992) {
                $(".signposting .signpost.slick-current").removeClass('slick-current');
                $(".signposting .signpost.add-current").addClass('slick-current');
            }
        });

        $(".signposting .signposts").slick({
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 0,
            dots: false,
            arrows: false,
responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                    }
                }
            ]
        })

        $(".signposting .signpost").on("mouseover", function () {
            if(!$(this).hasClass('slick-current')) {
                $(".signposting .signpost.slick-current").removeClass('slick-current');
                $(this).addClass('slick-current');
            }
        });
    }
});